import React, { useContext, useEffect, useState } from 'react';

import useScreenOrientation from '../hooks/useScreenOrientation';

export interface LayoutContextValue {
  setShowNavigationSection: (value: boolean) => void;
  showNavigationSection: boolean;
}

export const LayoutContext = React.createContext<LayoutContextValue>({
  setShowNavigationSection: () => undefined,
  showNavigationSection: false
});

export const LayoutProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const screenOrientation = useScreenOrientation();
  const [showNavigationSection, setShowNavigationSection] = useState(false);

  useEffect(() => {
    setShowNavigationSection(false);
  }, [screenOrientation]);

  return (
    <LayoutContext.Provider value={{ showNavigationSection, setShowNavigationSection }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
